export default {
  settingLogisticsStrategyConfig: {
    orderAmount: 'Delivery method specified when the order amount meets a certain threshold',
    district: 'Delivery method specified when the delivery address is in a specified province, city, or district',
    storehouse: 'Delivery method specified for a specified warehouse',
    goods: 'Delivery method specified for specified product',
    logisticsStrategy: 'Logistics Strategy',
    logisticsStrategyText: 'Rules can be dragged to change the order',
    setOrderAmount: 'Set Order Amount',
    setProvinces: 'Set province, city, and district',
    setWarehouse: 'Set Warehouse',
    designatedProduct: 'Set Specified Products',
    logisticsSettings: 'Logistics Settings',
    freightRadio: 'Priority given to the lowest shipping cost',
    priorityRadio: 'Priority given to the highest priority level',
    defaultLogistics: 'Default Logistics',
    defaultLogisticsText: 'Logistics that can be used by default and serve as a backup when logistics matching fails',
    table: {
      packageBilling: 'Package Billing',
      packageBillingRules: 'Please enter the package billing',
      businessName: 'Courier Service Name',
      businessNameRules: 'Please select business name',
      logisticsProviderName: 'Logistics Provider Name',
      logisticsProviderNameRules: 'Please select logistics provider name',
    },
    selectDesignatedLogisticsBusiness: 'Please select specified logistics service',
    selectDesignatedLogisticsProvider: 'Please select specified logistics provider',
    pricePackage: 'RMB/Package',
    confirmText: 'Whether to save the current operation？'
}
};
